export default __webpack_public_path__ + "static/media/business-woman-min.d6f13a66.jpg";